// extracted by mini-css-extract-plugin
export var infoRow = "_st-2";
export var labelContainer = "_st-0";
export var rightInfo = "_st-1";